function StartScreen(props) {
  function themeChoice(selected) {
    props.setTheme(selected.currentTarget.textContent);
  }

  function playerChoice(selected) {
    let x = selected.currentTarget.textContent;
    if (x === "1") {
      props.setPlayers([1]);
    } else if (x === "2") {
      props.setPlayers([1, 2]);
    } else if (x === "3") {
      props.setPlayers([1, 2, 3]);
    } else if (x === "4") {
      props.setPlayers([1, 2, 3, 4]);
    }
  }

  function gridChoice(selected) {
    props.setGrid(selected.currentTarget.textContent);
  }

  return (
    <div className={props.gameActive ? "off" : "start-screen"}>
      <h1>memory</h1>
      <div className="create-board-card">
        <div className="selection-container">
          <h2>Select Theme</h2>
          <div className="button-container">
            <button
              onClick={(e) => themeChoice(e)}
              className={props.theme === "Numbers" ? "button-active" : "button"}
            >
              Numbers
            </button>
            <button
              onClick={(e) => themeChoice(e)}
              className={props.theme === "Icons" ? "button-active" : "button"}
            >
              Icons
            </button>
          </div>
        </div>
        <div className="selection-container">
          <h2>Number of Players</h2>
          <div className="button-container">
            <button
              onClick={(e) => playerChoice(e)}
              className={
                props.players.length === 1 ? "button-active" : "button"
              }
            >
              1
            </button>
            <button
              onClick={(e) => playerChoice(e)}
              className={
                props.players.length === 2 ? "button-active" : "button"
              }
            >
              2
            </button>
            <button
              onClick={(e) => playerChoice(e)}
              className={
                props.players.length === 3 ? "button-active" : "button"
              }
            >
              3
            </button>
            <button
              onClick={(e) => playerChoice(e)}
              className={
                props.players.length === 4 ? "button-active" : "button"
              }
            >
              4
            </button>
          </div>
        </div>
        <div className="selection-container">
          <h2>Grid Size</h2>
          <div className="button-container">
            <button
              onClick={(e) => gridChoice(e)}
              className={props.grid === "4x4" ? "button-active" : "button"}
            >
              4x4
            </button>
            <button
              onClick={(e) => gridChoice(e)}
              className={props.grid === "6x6" ? "button-active" : "button"}
            >
              6x6
            </button>
          </div>
        </div>
        <button id="start-button" onClick={props.startGame}>
          Start Game
        </button>
      </div>
    </div>
  );
}

export default StartScreen;
